module.exports = __webpack_public_path__ + "images/howtouse/checkmark_f515a86a650dfbda57a44e540ba32c4c.svg";